import styled from 'styled-components';

import { SingleSelectDefault } from '@/core/components/Select';
import { MarginWrapper } from '@/core/components/MarginWrapper';

import { breakpoint } from '@/themes/breakpoints';

export const FeaturedCardImage = styled.img`
  height: 400px;
  object-fit: cover;
  object-position: 50% 50%;
`;

export const ContentWrapper = styled.div`
  max-width: var(--max-margin-wrapper-width);
  margin: 40px 16px;

  @media ${breakpoint.sm} {
    margin: 40px 32px;
  }

  @media ${breakpoint.md} {
    margin: 40px 80px;
  }

  @media ${breakpoint.lg} {
    position: relative;
    z-index: 1;
    margin: 40px auto;
  }
`;

export const StyledSelect = styled(SingleSelectDefault)`
  width: 100%;
  min-width: 280px;
  height: 56px;

  @media ${breakpoint.md} {
    max-width: 280px;
  }
`;

export const PaginationWrapper = styled(MarginWrapper)`
  padding-bottom: 160px;
`;

export const SelectsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  gap: 12px;

  @media ${breakpoint.sm} {
    gap: 24px;
    flex-direction: row;
    justify-content: stretch;
  }

  @media ${breakpoint.md} {
    flex-direction: row;
    justify-content: space-between;
  }

  &[data-userway-s3-2-styled="true"] {
    path {
      fill: var(--user-way-dark-contrast-color-2);
    }
  }
`;
